import React from "react";
import { ExternalLink } from "lucide-react";
import { SOURCE_PAGE, OFFICIAL_APPLICATION, KAMRAN } from "../../data/programs";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-aiou-paper border-t border-aiou-sand py-14"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white border border-aiou-sand overflow-hidden">
                <img
                  src="/aiou-logo.png"
                  alt="AIOU"
                  className="h-9 w-9 object-contain"
                />
              </span>
              <div className="font-serif text-lg text-aiou-ink leading-tight">
                AIOU <span className="text-aiou-steel">International</span>
              </div>
            </div>
            <p className="mt-4 text-sm text-aiou-slate leading-relaxed max-w-sm">
              An independent guidance site for international students who wish
              to enrol at Allama Iqbal Open University. We are not affiliated
              with AIOU.
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-wider text-aiou-mute font-semibold">
              Official links
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a
                  href={SOURCE_PAGE}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-aiou-slate hover:text-aiou-steel"
                >
                  Directorate of International Collaboration
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href={OFFICIAL_APPLICATION}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-aiou-slate hover:text-aiou-steel"
                >
                  Online Admission Portal
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://aaghi.aiou.edu.pk"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-aiou-slate hover:text-aiou-steel"
                >
                  Aaghi LMS (Online Learning)
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://aiou.edu.pk"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-aiou-slate hover:text-aiou-steel"
                >
                  AIOU Main Website
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-wider text-aiou-mute font-semibold">
              Free guidance
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="text-aiou-slate">{KAMRAN.name}</li>
              <li>
                <a
                  href={`https://wa.me/${KAMRAN.phone.replace(/[^0-9]/g, "")}`}
                  className="text-aiou-slate hover:text-aiou-steel"
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp: {KAMRAN.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${KAMRAN.email}`}
                  className="text-aiou-slate hover:text-aiou-steel"
                >
                  {KAMRAN.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-aiou-sand flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-aiou-mute">
          <div>
            © {new Date().getFullYear()} AIOU International — Independent
            guidance site.
          </div>
          <div>
            Fee figures are from Spring-2026 prospectuses · Always verify on{" "}
            <a
              href={SOURCE_PAGE}
              target="_blank"
              rel="noreferrer"
              className="underline hover:text-aiou-steel"
            >
              aiou.edu.pk
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
